import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";
import Abutton from '../../library/ExtendedObjects/AButton.js';

export default class trayBaseSlider extends AContainer
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.tabs = [
          gameData.maskLocalization.getLocalizedString("tabNames.trim", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.color", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.patterns", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.faces", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.patches", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.letters", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.paint", gameData.maskLocalization.isDefault)
        ];

        this.accessories = [];
        this.isActive = false;

        this.hasSlider = true;
        this.stepper = 0;
        this.maxVisible = 5;
        this.sliderPos = {
            x: 55,
            upStart:-405,
            upEnd: -355,
            downStart: 386,
            downEnd: 336
        };

        this.createTray();
    }

    createTray()
    {
        if(this.type !== "faces" && this.type !== "patterns"){
            this.btnUp = this.scene.addButton(this.sliderPos.x, this.sliderPos.upStart, "Btn_Up", null, ()=>{this.scrollUp();}, this);
            this.btnDown = this.scene.addButton(this.sliderPos.x, this.sliderPos.downStart, "Btn_Down", null, ()=>{this.scrollDown();}, this);
            this.toggleBtns();
        }
        
        this.nameplate = this.scene.addImage(this.sliderPos.x, -this.scene.maskAdj.y, "Tab", this);
        this.nameplateText = this.scene.addText(this.sliderPos.x, -this.scene.maskAdj.y + this.nameplate.height/2, 22, "0xFFFFFF", gameData.fonts.din_alternatebold, this.tabs[this.ind], this, true);

        this.cursor = this.scene.addImage(0, 0, "faceCursor", this);
        this.cursor.setScale(0, 0);

        this.type === "faces" ? this.nameplate.tint = this.cursor.tint = "0xf75646" : this.nameplate.tint = this.cursor.tint = "0x97cc44";
    }

    checkScrollState()
    {
        this.toggleBtns();

        if(this.stepper === 0) {
            this.scene.addTween(this.btnUp, 250, {y:this.sliderPos.upStart}, Phaser.Math.Easing.Quadratic.Out);
            this.scene.addTween(this.btnDown, 250, {y:this.sliderPos.downEnd}, Phaser.Math.Easing.Quadratic.Out);
        }
        else if(this.stepper > 0 && this.stepper + this.maxVisible < this.accessories.length) {
            this.scene.addTween(this.btnUp, 250, {y:this.sliderPos.upEnd}, Phaser.Math.Easing.Quadratic.Out);
            this.scene.addTween(this.btnDown, 250, {y:this.sliderPos.downEnd}, Phaser.Math.Easing.Quadratic.Out);
        }
        else if(this.stepper > 0 && this.stepper + this.maxVisible >= this.accessories.length) {
            this.scene.addTween(this.btnUp, 250, {y:this.sliderPos.upEnd}, Phaser.Math.Easing.Quadratic.Out);
            this.scene.addTween(this.btnDown, 250, {y:this.sliderPos.downStart}, Phaser.Math.Easing.Quadratic.Out);
        }

        this.scene.addDelay(250, ()=>{this.toggleBtns(true);});
    }

    scrollUp()
    {
        this.stepper--;

        for(let i=0;i<this.accessories.length;i++){
            let newY = this.accessories[i].y + this.accessories[this.stepper].height;

            this.scene.killTween(this.accessories[i]);
            this.scene.addTween(this.accessories[i], 250, {y:newY}, Phaser.Math.Easing.Quadratic.Out);
        }
        let newY = this.cursor.y + this.accessories[this.stepper].height;
        this.scene.addTween(this.cursor, 250, {y:newY}, Phaser.Math.Easing.Quadratic.Out);

        this.checkScrollState();
    }

    scrollDown()
    {
        this.stepper++;

        for(let i=0;i<this.accessories.length;i++){
            let newY = this.accessories[i].y - this.accessories[this.stepper].height;

            this.scene.killTween(this.accessories[i]);
            this.scene.addTween(this.accessories[i], 250, {y:newY}, Phaser.Math.Easing.Quadratic.Out);
        }
        let newY = this.cursor.y - this.accessories[this.stepper].height;
        this.scene.addTween(this.cursor, 250, {y:newY}, Phaser.Math.Easing.Quadratic.Out);

        this.checkScrollState();
    }

    tweenInCursor(accessory)
    {
        this.cursor.x = accessory.x;
        this.cursor.y = accessory.y + accessory.height/2;
        this.cursor.setScale(0, 0);

        this.scene.killTween(this.cursor);
        this.scene.addTween(this.cursor, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Back.Out);
    }

    tweenOutCursor()
    {
        this.scene.killTween(this.cursor);
        this.scene.addTween(this.cursor, 100, {scaleX:0, scaleY:0}, Phaser.Math.Easing.None);
    }

    toggleBtns(onOff)
    {
        for(let i=0;i<this.list.length;i++){
            if(this.list[i] instanceof Abutton) this.list[i].setEnabled(onOff);
        }

        if(this.btnUp) this.btnUp.setEnabled(onOff);
        if(this.btnDown) this.btnDown.setEnabled(onOff);
    }
}